import React from 'react';
import PropTypes from 'prop-types';
import DescribedField from '../DescribedField';
import RichTextEditor from '../RichTextEditor';

/**
 * AboutBlockEditor — Editor do bloco Sobre
 * TODO 4.6
 *
 * Props:
 *   - value: { html }
 *   - onChange: (patch) => void
 *   - context: { siteType, scope, ... }
 */
const AboutBlockEditor = ({ value = {}, onChange }) => {
  const { html = '' } = value;

  return (
    <DescribedField
      label="Conteúdo"
      description="Texto livre com formatação básica (negrito, itálico, listas, links). Aqui você conta quem é, trajetória, diferenciais e filosofia de atendimento. Idealmente 2 a 4 parágrafos curtos e diretos. HTML inseguro é removido automaticamente. Limite: 5000 caracteres."
    >
      <RichTextEditor
        value={html}
        onChange={(newHtml) => onChange({ ...value, html: newHtml })}
        placeholder="Fale sobre você, sua trajetória e diferenciais..."
        maxLength={5000}
        label="Sobre"
      />
    </DescribedField>
  );
};

AboutBlockEditor.propTypes = {
  value: PropTypes.shape({
    html: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  context: PropTypes.object,
};

export default AboutBlockEditor;
